import { api } from './index';
import { ApiResponse } from '../types';

export const authService = {
  login: async (email: string) => {
    const response = await api.post('/auth/login', { email });
    if (response.data.status === 'error') {
      throw new Error(response.data.message || 'Login fehlgeschlagen');
    }
    return response.data.data;
  },

  getUserRole: async (): Promise<{
    role: 'admin' | 'reader' | 'qs' | 'super_qs' | 'unauthorized';
    permissions: string[];
    user: {
      name: string;
      email: string;
      organization: {
        id: string;
        name: string;
        email: string;
        status: string;
      } | null;
    };
  }> => {
    const response = await api.get<ApiResponse<{
      role: 'admin' | 'reader' | 'qs' | 'super_qs' | 'unauthorized';
      permissions: string[];
      user: {
        name: string;
        email: string;
        organization: {
          id: string;
          name: string;
          email: string;
          status: string;
        } | null;
      };
    }>>('/auth/user-role');
    return response.data.data;
  }
};



